// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1L5qW","header":"PatientQuestionnaire_header__3AgBB","info":"PatientQuestionnaire_info__2qIMd"};